import script from "./GuideSectionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideSectionPage.vue?vue&type=script&setup=true&lang=ts"

import "./GuideSectionPage.vue?vue&type=style&index=0&id=b37b496a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b37b496a"]])

export default __exports__